import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    /**
     * ブレイクポイント
     */
    breakpoints: {
      xs: 374,
      sm: 767,
      md: 1023,
      lg: 1279,
      xl: Infinity,
    },
    /**
     * メニュー状態
     */
    menu: false,
    /**
     * fixed状態
     */
    fixed: false,
    /**
     * アスペクト数値
     */
    aspect: 0.484375,
    /**
     * ホームURL
     */
    homeUrl: ((): string => {
      if (location.href.indexOf('localhost') !== -1) {
        return 'http://localhost:8080/hotels/newgraduate';
      } else if (location.href.indexOf('p71.sndbx.work') !== -1) {
        return 'https://p71.sndbx.work/hotels/newgraduate';
      } else {
        return 'https://www.jrk-hotels.co.jp/newgraduate';
      }
    })(),
  },
  getters: {
    breakpoints(state: any): any {
      return state.breakpoints;
    },
    menu(state: any): any {
      return state.menu;
    },
    fixed(state: any): any {
      return state.fixed;
    },
    aspect(state: any): any {
      return state.aspect;
    },
    homeUrl(state: any): any {
      return state.homeUrl;
    },
  },
  mutations: {
    setMenu(state: any, menu: any): void {
      state.menu = menu;
    },
    setFixed(state: any, fixed: any): void {
      state.fixed = fixed;
    },
  },
  actions: {

  },
});
